<template>
  <v-combobox
    v-bind="$attrs"
    :value="value"
    :items="schoolOptions"
    item-text="name"
    item-value="name"
    :return-object="false"
    :filter="filterSchool"
    :hint="hint"
    :menu-props="{ maxHeight: 360 }"
    v-on="forwardedListeners"
    @input="handleInput"
    @change="handleChange"
  >
    <template v-slot:item="{ item }">
      <v-list-item-content>
        <v-list-item-title>{{ item.name }}</v-list-item-title>
        <v-list-item-subtitle>{{ item.type }}</v-list-item-subtitle>
      </v-list-item-content>
    </template>
    <template v-slot:no-data>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>未找到匹配项</v-list-item-title>
          <v-list-item-subtitle>可直接输入并保存当前内容</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-combobox>
</template>

<script>
import { CREW_SCHOOL_OPTIONS } from '@/util/crewSchoolOptions'

export default {
  name: 'crew-school-combobox',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: '',
    },
    hint: {
      type: String,
      default: '可选择建议项，也可直接输入',
    },
  },
  data() {
    return {
      schoolOptions: CREW_SCHOOL_OPTIONS,
    }
  },
  computed: {
    forwardedListeners() {
      const listeners = { ...this.$listeners }
      delete listeners.input
      delete listeners.change
      return listeners
    },
  },
  methods: {
    filterSchool(item, queryText, itemText) {
      const query = (queryText || '').toLocaleLowerCase().trim()
      const text = `${itemText || item.name || ''} ${item.type || ''}`
        .toLocaleLowerCase()
        .trim()
      return text.includes(query)
    },
    normalizeValue(value) {
      const normalizedValue =
        value && typeof value === 'object' ? value.name : value
      return normalizedValue == null ? '' : normalizedValue
    },
    handleInput(value) {
      this.$emit('input', this.normalizeValue(value))
    },
    handleChange(value) {
      const normalizedValue = this.normalizeValue(value)
      this.$emit('input', normalizedValue)
      this.$nextTick(() => this.$emit('change', normalizedValue))
    },
  },
}
</script>
